import React from "react";

import "./style.css";

import userImg from "../../assets/user.png";

const depoimentos = [
  {
    nome: "João da Silva",
    cargo: "Caminhoneiro Autônomo",
    texto:
      "Fui atendido rápido no WhatsApp e a peça chegou em 2 dias. Recomendo muito!",
    imagem: userImg,
  },
  {
    nome: "Transportes Maringá",
    cargo: "Gerente de Frotas",
    texto:
      "Empresa confiável, já fizemos várias compras e sempre chegou no prazo.",
    imagem: userImg,
  },
  {
    nome: "Carlos",
    cargo: "Representante Comercial",
    texto:
      "O atendimento técnico no WhatsApp é excelente. Me ajudaram a identificar o modelo certo.",
    imagem: userImg,
  },
];

const FeedBacks = () => {
  return (
    <section className="depoimentos-section">
      <h2 className="depoimentos-titulo">O que dizem nossos clientes</h2>
      <div className="depoimentos-container">
        {depoimentos.map((d, index) => (
          <div className="depoimento-card" key={index}>
            <img src={d.imagem} alt={d.nome} className="depoimento-avatar" />
            <p className="depoimento-texto">“{d.texto}”</p>
            <h3 className="depoimento-nome">{d.nome}</h3>
            <p className="depoimento-cargo">{d.cargo}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeedBacks;
